module.exports = __webpack_public_path__ + "d70c49a1750e399344e77737be6eac71.png";